var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('b-container',{staticClass:"text-center"},[_c('a',{attrs:{"href":"https://spendid.io"}},[_c('img',{attrs:{"src":"footer-logo.png","width":"60","height":"60"}})]),_c('p',{staticClass:"text-white mt-2 mb-0 font-weight-bold"},[_vm._v("\"Done For You\" Predictive Budgeting")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }